module.exports = __webpack_public_path__ + "img/gift-ui-03.bc3c8141.png";